import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { AsyncState } from '../../components/AsyncState.js';
import { CampaignForm } from '../../components/campaigns/CampaignForm.js';
import { CampaignTemplates } from '../../components/campaigns/CampaignTemplates.js';
import { getCampaign } from '../../lib/api/campaigns.js';
import { qk } from '../../lib/query-keys.js';

export const Route = createFileRoute('/_authed/campaigns/$campaignId')({
  component: CampaignEditPage,
});

function CampaignEditPage() {
  const { campaignId } = Route.useParams();
  const id = Number(campaignId);
  const query = useQuery({ queryKey: qk.campaigns.detail(id), queryFn: () => getCampaign(id) });

  return (
    <div>
      <AsyncState query={query}>
        {(c) => (
          <>
            <h2 className="mb-4 text-xl font-semibold text-neutral-900">
              Edit campaign: <span className="font-mono text-base">{c.campaign_key}</span>
            </h2>
            <CampaignForm existing={c} />
            <CampaignTemplates campaignId={c.id} />
          </>
        )}
      </AsyncState>
    </div>
  );
}
